const About = () => {
  return (
    <div className="about-section" id="About">
    </div>
  );

}

export default About;
